import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Products } from "./pages/Products";
import { CategoryDetail } from "./pages/CategoryDetail";
import { Production } from "./pages/Production";
import { Certifications } from "./pages/Certifications";
import { Contact } from "./pages/Contact";
import { initializeGA } from "./utils/analytics";
import { usePageTracking } from "./hooks/usePageTracking";

function AppContent() {
  // Track page views on route changes
  usePageTracking();

  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hakkimizda" element={<About />} />
        <Route path="/urunler" element={<Products />} />
        <Route path="/urunler/:categorySlug" element={<CategoryDetail />} />
        <Route path="/uretim-surecleri" element={<Production />} />
        <Route path="/sertifikalar" element={<Certifications />} />
        <Route path="/iletisim" element={<Contact />} />
      </Routes>
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-right" />
    </>
  );
}

function App() {
  // Initialize Google Analytics on component mount
  useEffect(() => {
    initializeGA();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
